import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'

import { FieldWrapper } from 'src/components'

import styles from './zip-code-input.module.scss'

import { IField } from 'src/interfaces'

const getPhoneWithMask = (str: string) => {
  return str
    .split('')
    .reduce((a, c, i) => {
      if (i == 6) a.push('')
      a.push(c)
      if (i == 2) a.push('')
      return a
    }, [] as string[])
    .join('')
}

const ZipCodeInput = (props: IField) => {
  const { name, placeholder } = props

  const { t } = useTranslation()

  const [field, meta, { setValue }] = useField({ name })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { defaultValue, value: originalValue } = event.currentTarget
    let zipCodeValue = originalValue

    if (zipCodeValue.length > 5) {
        zipCodeValue = zipCodeValue.substring(0, zipCodeValue.length - 1)
    }

      zipCodeValue = zipCodeValue.replace(/[^0-9.]/g, '')

    if (
      originalValue.length < defaultValue.length &&
      defaultValue[defaultValue.length - 1] === '-'
    ) {
    } else {
        zipCodeValue = getPhoneWithMask(zipCodeValue)
    }

    setValue(zipCodeValue || '')
  }

  return (
    <FieldWrapper {...props}>
      <input
        className={cx(
          styles.basicInput,
          meta.error && meta.touched && styles.error,
        )}
        placeholder={placeholder ? t(`placeholder.${placeholder}`) : undefined}
        {...field}
        onChange={handleChange}
      />
    </FieldWrapper>
  )
}

export default ZipCodeInput
